import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Route, Routes } from 'react-router-dom';
import axios from 'axios';
//import PrivateRoute from './Routes/PrivateRoute';
//import usePageTitle from './Components/_GlobalFunctions/PageTitle';
import Handshake from './Components/Handshake/Handshake';
import { MainTheme } from './Themes/MainTheme';
import Home from './Components/Home/Home';
import Navbar from './Components/Navbar/Navbar';
import Login from './Components/Login/Login';
import LoginCheckRoute from './Routes/LoginCheckRoute';
import AccountSettings from './Components/AccountSettings/AccountSettings';
import UserPreferences from './Components/UserPreferences/UserPreferences';
import ManageUsers from './Components/ManageUsers/ManageUsers';
import GunTV from './Components/GunTV/GunTV';
import BrandLandingPage from './Components/BrandLandingPage/BrandLandingPage';
import HornadyPIM from './Components/HornadyPIM/HornadyPIM';
import HornadyPIMItem from './Components/HornadyPIM/HornadyPIMItem';
import ManufacturerRoute from './Routes/ManufacturerRoute';
import TSWRoutes from './Routes/TSWRoutes';
import Landing from './Components/Landing/Landing';
import Footer from './Components/Footer/Footer';
import SmartOrders from './Components/SmartOrders/SmartOrders';
import Planograms from './Components/Planograms/Planograms';
import SettingsTable from './Components/SmartOrders/Components/SettingsTable';
import Returns from './Components/Returns/Returns';
import Orders from './Components/Orders/Orders';
import PrivacyPolicy from './Components/Landing/Components/PrivacyPolicy';
import OptIn from './Components/Landing/Components/OptIn';
import ContactUs from './Components/Landing/Components/ContactUs';
import ItemSpecSheet from './Components/ItemSpecSheet/ItemSpecSheet';
import ImageLibrary from './Components/ImageLibrary/ImageLibrary';
import { useSelector } from 'react-redux';
//import BuildAttr from './Components/HornadyPIM/BuildAttr';

function App() {
  if (window.location.host !== 'localhost:3000') {
    axios.defaults.baseURL = 'https://ninja.sportssouth.dev';
  }

  const defaultTheme = createTheme(MainTheme);
  const userPermission = useSelector((state) => state.userPermission.value);

  return (
    <ThemeProvider theme={defaultTheme}>
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/gun-tv/*' element={<GunTV />} />
        <Route path='/landing' element={<Landing />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/opt-in' element={<OptIn />} />
        <Route path='/contact-us' element={<ContactUs />} />
        <Route path='/suggested-orders/*' element={<SmartOrders />} />
        <Route path='/planograms/*' element={<Planograms />} />
        <Route path='/smart-settings/*' element={<SettingsTable />} />
        <Route path='/returns' element={<Returns />} />
        <Route path='/orders' element={<Orders />} />
        <Route path='/item-spec-sheet/:itemNumber' element={<ItemSpecSheet />} />
        <Route
          element={
            <LoginCheckRoute>
              <Navbar />
              <Footer />
            </LoginCheckRoute>
          }
        >
          <Route index element={<Home />} />
          <Route path='/page/*' element={<TSWRoutes />} />
          <Route path='/handshake' element={<Handshake />} />
          <Route path='/account-settings' element={<AccountSettings />} />
          <Route path='/user-preferences' element={<UserPreferences />} />
          <Route path='/manage-users' element={<ManageUsers />} />
          <Route path='/image-library' element={<ImageLibrary />} />
          <Route path='/brand-landing-page/:id' element={<BrandLandingPage />} />
          <Route path='/hornady-pim-items' element={<HornadyPIM />} />
          <Route path='/hornady-pim-item/:id' element={<HornadyPIMItem />} />
          <Route path='/manufacturer/*' element={<ManufacturerRoute />} />
          {/* <Route path='/build-attr' element={<BuildAttr />} /> */}
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;
